// @flow

export const CLUSTER_USAGE_TAB_KEYS = {
  THROUGHPUT: 'Throughput',
  CONNECTORS: 'Connectors',
  KSQLDB: 'ksqlDB',
  CLUSTER_LINKING: 'Cluster Linking',
  TABLEFLOW: 'Tableflow',
  RTCE: 'RTCE',
};
